module.exports = __webpack_public_path__ + "img/step2-dark.a5b416db.png";